export default "<app-page-content pageUrl=\"project-management-services/our-programmes\"></app-page-content>\r\n"